"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createQueryFilter = exports.getAllChildCategories = exports.createFilterQuery = exports.getFiltersWithoutCategories = exports.getFilterFromCategories = void 0;
var FILTER_TYPE = 'right-view-selector';

var getFilterFromCategories = function getFilterFromCategories(allCategories, categoryFilter) {
  var query = createFilterQuery(allCategories, categoryFilter);
  return createQueryFilter(categoryFilter, query);
};

exports.getFilterFromCategories = getFilterFromCategories;

var getFiltersWithoutCategories = function getFiltersWithoutCategories(filters) {
  if (Array.isArray(filters) && filters.length) {
    return filters.filter(function (filter) {
      return filter.filterType !== FILTER_TYPE;
    });
  } else {
    return filters;
  }
};

exports.getFiltersWithoutCategories = getFiltersWithoutCategories;

var createFilterQuery = function createFilterQuery(allCategories, categoryFilter) {
  return function (data) {
    return data.filter(function (row) {
      var rowContainsCategory = false;
      var hideRowBasedOnFilterVisibility = false;
      var flatAllCategories = getAllChildCategories(allCategories);
      var categoriesToHide = flatAllCategories.filter(function (cat) {
        return !cat.isVisible && cat.id !== 0 && cat.id !== -1;
      }).map(function (cat) {
        return cat.id;
      });
      var rowCats = row.productCategories.map(function (c) {
        return c.categoryId;
      }); // filter out first by visibility (selected category with isVisible false should be hidden)

      rowCats.forEach(function (rowCat) {
        if (categoriesToHide.includes(rowCat)) {
          rowContainsCategory = false;
          hideRowBasedOnFilterVisibility = true;
        }
      }); // then filter by what categories are selected

      if (!hideRowBasedOnFilterVisibility && Array.isArray(categoryFilter) && categoryFilter.length) {
        categoryFilter.forEach(function (cat) {
          // if not 0 or -1, allow only rows that include this filter
          if (cat !== 0 && cat !== -1 && rowCats.includes(cat)) {
            rowContainsCategory = true; // 0 means allow all rows
          } else if (cat === 0) {
            rowContainsCategory = true; // -1 means allow only rows with no categories
          } else if (cat === -1) {
            if (rowCats.length === 0) {
              rowContainsCategory = true;
            }
          }
        });
      }

      return rowContainsCategory;
    });
  };
};

exports.createFilterQuery = createFilterQuery;

var getAllChildCategories = function getAllChildCategories(categories) {
  var arrOfCategories = [];

  var loopThroughCategories = function loopThroughCategories(category) {
    arrOfCategories.push(category);

    if (category.children.length) {
      category.children.forEach(function (childCat) {
        arrOfCategories.push(childCat);

        if (category.children.length) {
          loopThroughCategories(childCat);
        }
      });
    }
  };

  categories.forEach(function (c) {
    return loopThroughCategories(c);
  });
  return arrOfCategories;
};

exports.getAllChildCategories = getAllChildCategories;

var createQueryFilter = function createQueryFilter(categoryFilter, query) {
  return {
    name: 'category',
    value: categoryFilter,
    filterType: FILTER_TYPE,
    query: query
  };
};

exports.createQueryFilter = createQueryFilter;